import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { PopUpNotification } from './components/PopUpNotification';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { ProductReveal } from './components/ProductReveal';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Comparison } from './components/Comparison';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0A1628] text-white font-sans selection:bg-[#C6F432] selection:text-[#0A1628]" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PopUpNotification data-id="element-2" />
      <UrgencyBar data-id="element-3" />

      <main data-id="element-4">
        <Hero data-id="element-5" />
        <TestimonialsStrip data-id="element-6" />
        <PainPoints data-id="element-7" />
        <ProductReveal data-id="element-8" />
        <Modules data-id="element-9" />
        <Bonuses data-id="element-10" />
        <Pricing data-id="element-11" />
        <Comparison data-id="element-12" />
        <Testimonials data-id="element-13" />
        <Guarantee data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
    </div>;
}